import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'product', loadChildren: () => import('./product/product.module').then(m => m.ProductModule) },
  { path: 'shopping-cart', loadChildren: () => import('./shopping-cart/shopping-cart.module').then(m=>m.ShoppingCartModule)},
  { path: 'fast-selling', loadChildren: () => import('./fast-selling/fast-selling.module').then(m=>m.FastSellingModule)},
  { path: 'consignment', loadChildren: () => import('./consignment/consignment.module').then(m=>m.ConsignmentModule)},
  { path: 'bulk-purchase', loadChildren: () => import('./bulk-purchase/bulk-purchase.module').then(m=>m.BulkPurchaseModule)},
  { path: 'counting', loadChildren: () => import('./counting/counting.module').then(m=>m.FastSellingModule)},
  { path: 'settings', loadChildren: () => import('./settings/retail-settings.module').then(m=>m.RetailSettingsModule)},
  { path: 'staff-sales-report', loadChildren: () => import('./staff-sales-report/staff-sales-report.module').then(m=>m.StaffSalesReportModule)},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RetailRoutingModule { }
